import { WeightUnit as e } from "@ancon/wildcat-types";
import t from "../shared/gramToKiloGram.mjs";
function a(r, o, m = e.Kilogram) {
  return m === e.Kilogram ? r * Number(Number(o).toFixed(3)) : r * t(o);
}
export {
  a as default
};
